import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { Adal4Service } from "adal-angular4";
import { TokenService } from "./token.service";
import { ItemAuditoria } from '../classes/ItemAuditoria';

@Injectable()
export class AuditoriaService {
  private headers = new Headers({'Content-Type': 'application/json'});
  options;
  token;
  

  constructor(private AdalService: Adal4Service, private http: Http, private tokenService: TokenService) { 
    this.token = this.AdalService.userInfo.token;    
    this.headers = new Headers({'content-Type': 'application/json'});
    this.headers.append('authorization',`bearer ${this.token}`) 
    }


  getItemsAuditoria(): Promise<ItemAuditoria[]> {
    let url = "/api/auditoria/getAuditorias";
    this.tokenService.handleTokenExpiration();  
    return this.http.get(url, { headers: this.headers })
      .toPromise()
      .then(auditorias => auditorias.json())// as Array<ItemAuditoria>)
      .catch(this.handleError);
  }

  updateAuditorias(itensAuditoria: Array<ItemAuditoria>): Promise<string> {
    
    let url = "/api/auditoria/setAuditorias"; //Mudar para newgroup
    this.tokenService.handleTokenExpiration();  
    return this.http
      .post(url, JSON.stringify(itensAuditoria), { headers: this.headers })
      .toPromise()
      .then(result => result.text())
      .catch(this.handleError);
      
  }

  handleError(error: any): Promise<any> {
    console.error('Ocorreu um erro:', error);
    return Promise.reject(error.message || error);
  //return `Ocorreu um erro ao tentar inserir um relatório: ${error.text}`;
  }
}



// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/shared/services/auditoria.service.ts